import { NotificationData, notifications } from "@mantine/notifications"
import { ReactNode } from "react"

const NotificationMessage = (props: { message: ReactNode; Icon: any }) => {
  return (
    <div className="flex items-center gap-2 text-[15px] text-white">
      <props.Icon
        className={`
          [&_g]:stroke-[2.5]

          [&_path]:stroke-[2.5]
        `}
      />
      <div>{props.message}</div>
    </div>
  )
}

export const toast = {
  success: (message: ReactNode, notification?: NotificationData) => {
    return notifications.show({
      position: "top-center",
      className: "success",
      ...notification,
      message: <NotificationMessage message={message} Icon={IconMageCheckCircle} />,
    })
  },
  error: (message: ReactNode, notification?: NotificationData) => {
    return notifications.show({
      position: "top-center",
      className: "danger",
      ...notification,
      message: <NotificationMessage message={message} Icon={IconMageMultiplyCircle} />,
    })
  },
  info: (message: ReactNode, notification?: NotificationData) => {
    return notifications.show({
      position: "bottom-right",
      className: "info",
      ...notification,
      message: <NotificationMessage message={message} Icon={IconMageInformationCircle} />,
    })
  },
}
